import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#F7B500",
      contrastText: "#17110c",
    },
    secondary: {
      main: "#0f766e",
      contrastText: "#ffffff",
    },
    background: {
      default: "#fffaf3",
      paper: "#FFFFFF",
    },
    grey: {
      50: "#fcfbf9",
      100: "#f6f2ed",
      200: "#e9e2da",
      300: "#d8cec3",
      800: "#332b25",
    },
    text: {
      primary: "#241b16",
      secondary: "#6f6259",
    },
    divider: "rgba(67,20,7,0.10)",
  },

  shape: { borderRadius: 16 },

  typography: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: { fontWeight: 850, letterSpacing: "-0.045em", lineHeight: 1.02 },
    h2: { fontWeight: 850, letterSpacing: "-0.04em", lineHeight: 1.05 },
    h3: { fontWeight: 850, letterSpacing: "-0.035em", lineHeight: 1.08 },
    h4: { fontWeight: 850, letterSpacing: "-0.03em", lineHeight: 1.1 },
    h5: { fontWeight: 800, letterSpacing: "-0.02em", lineHeight: 1.16 },
    h6: { fontWeight: 800, letterSpacing: "-0.01em" },
    button: {
      fontWeight: 800,
      letterSpacing: "-0.01em",
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          backgroundColor: "#fffaf3",
          scrollBehavior: "smooth",
        },
        body: {
          backgroundColor: "#fffaf3",
          color: "#241b16",
          textRendering: "optimizeLegibility",
        },
        "::selection": {
          backgroundColor: "rgba(247,181,0,0.32)",
        },
        "@media (prefers-reduced-motion: reduce)": {
          "html:focus-within": {
            scrollBehavior: "auto",
          },
          "*, *::before, *::after": {
            animationDuration: "0.01ms !important",
            animationIterationCount: "1 !important",
            scrollBehavior: "auto !important",
            transitionDuration: "0.01ms !important",
          },
        },
      },
    },

    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "rgba(255,250,243,0.88)",
          backdropFilter: "blur(18px)",
          borderBottom: "1px solid rgba(67,20,7,0.10)",
          color: "#241b16",
        },
      },
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },

    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 12,
          minHeight: 44,
          paddingLeft: 18,
          paddingRight: 18,
          transition:
            "transform 160ms ease, box-shadow 160ms ease, background-color 160ms ease, border-color 160ms ease",
          "&:focus-visible": {
            outline: "3px solid rgba(15,118,110,0.34)",
            outlineOffset: 2,
          },
        },
        contained: {
          boxShadow: "0 10px 24px rgba(33,20,12,0.12)",
        },
        containedPrimary: {
          color: "#17110c",
        },
      },
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          minWidth: 44,
          minHeight: 44,
          "&:focus-visible": {
            outline: "3px solid rgba(15,118,110,0.34)",
            outlineOffset: 2,
          },
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 750,
          backgroundColor: "rgba(17,17,17,0.06)",
        },
        clickable: {
          "&:focus-visible": {
            outline: "3px solid rgba(15,118,110,0.30)",
            outlineOffset: 2,
          },
        },
      },
    },

    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          border: "1px solid rgba(67,20,7,0.08)",
          boxShadow: "0 18px 48px rgba(67,20,7,0.08)",
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            minHeight: 48,
            borderRadius: 14,
            backgroundColor: "#fff",
          },
        },
      },
    },

    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          alignItems: "center",
        },
      },
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundImage: "none",
        },
      },
    },

    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 20,
        },
      },
    },

    MuiTableContainer: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: "1px solid rgba(17,17,17,0.08)",
          boxShadow: "0 10px 24px rgba(0,0,0,0.06)",
          overflow: "hidden",
        },
      },
    },

    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(17,17,17,0.03)",
        },
      },
    },
  },
});
